const autoNgTemplateLoaderTemplate1 = require('./auth-logs-datatable.html');

import controller from './auth-logs-datatable.controller';

export const authLogsDatatable = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    logs: '<',
    keyword: '<',
    sort: '<',
    limit: '<',
    totalItems: '<',
    currentPage: '<',
    contextFilter: '<',
    typeFilter: '<',
    feature: '@',

    onChangeContextFilter: '<',
    onChangeTypeFilter: '<',
    onChangeKeyword: '<',
    onChangeSort: '<',

    onChangeLimit: '<',
    onChangePage: '<',
  },
};
